import {
  Button,
  GenericLoader,
  If,
  Otp,
  useHasRequiredFormError,
  useI18n,
  widgets,
} from '@nosinovacao/nosid-mfe-common';
import { type UpdatePinProps } from '../-model/props';
import { SkeletonWooDark } from '@/components/skeleton/skeleton.woo-dark';

export function UpdatePinWooDark({ form, isLoading, submit }: Readonly<UpdatePinProps>) {
  const { t } = useI18n();
  const hasRequiredError = useHasRequiredFormError(form);
  return (
    <form
      data-tid="form-update-pin"
      className="flex size-full flex-col items-center"
      onSubmit={form.handleSubmit(submit)}
    >
      <SkeletonWooDark loading={isLoading} className="h-12 w-52">
        <Otp
          data-tid="otp-pin"
          id="pin"
          skin="woo-dark"
          length={widgets.PinCodeLength}
          value={form.value.pin}
          onChange={(v) => {
            form.setValue('pin', v);
          }}
        />
      </SkeletonWooDark>
      <div className="mt-auto grid w-full max-tablet:pb-8">
        <Button
          data-tid="button-submit-pin"
          skin="woo-dark"
          disabled={isLoading || form.pristine || hasRequiredError}
          className="tablet:w-fit"
        >
          <If condition={isLoading} otherwise={t('Pins.ChangePin.Submit')}>
            <GenericLoader className="size-6 animate-spin border-woo-green-100" />
          </If>
        </Button>
      </div>
    </form>
  );
}
